import { VideoEmbed } from './VideoEmbed';
export default VideoEmbed;